<template>
  <InvestorOnboardingStep :card-class="'panel celebration'">
    <View direction="column" align="center" gap="xl" class="content column">
      <img class="hero" src="/house.png" alt="" aria-hidden="true" />

      <View direction="column" gap="lg" align="center" class="copy">
        <View direction="column" gap="sm" align="center">
          <Text variant="h2">You’re all set!</Text>
          <Text variant="body-large" color="secondary" align="center" style="max-width: 25rem">
            {{
              store.joinedExistingCompany
                ? 'Your team’s properties are ready. The ones you work on show up on your dashboard.'
                : 'Let’s add your first property and kick off your Tallo journey'
            }}
          </Text>
        </View>

        <View padding-bottom="xl">
          <Button size="medium" @click="proceed">
            {{ store.joinedExistingCompany ? 'Go to properties' : 'Add first property' }}
          </Button>
        </View>
      </View>
    </View>
  </InvestorOnboardingStep>
</template>

<script setup lang="ts">
import { inject, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { Button, Text, View } from '@tallo/design-system';
import { onboardingContinueActionKey, useOnboardingStore } from '@tallo/investor/investor';
import { AppRouteNames, useNavigation } from '@tallo/investor/navigation';

import InvestorOnboardingStep from '../components/investor-onboarding-step.vue';

const router = useRouter();
const store = useOnboardingStore();
const { openNewPropertyOnboarding } = useNavigation();
const registerContinueAction = inject(onboardingContinueActionKey, () => undefined);

// Someone who joined a team has its properties waiting; a founder starts with their first one
function proceed() {
  if (store.joinedExistingCompany) {
    router.push({ name: AppRouteNames.INVESTOR_PORTFOLIO });
  } else {
    openNewPropertyOnboarding();
  }
}

onMounted(() => {
  registerContinueAction(proceed);
});
</script>

<style scoped>
.content {
  width: 100%;
  padding-left: var(--t-spacing-md);
  padding-right: var(--t-spacing-md);
}
.hero {
  width: clamp(120px, 20vw, 250px);
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 12px 28px rgba(0, 0, 0, 0.12));
}
.copy {
  max-width: 620px;
}
</style>
